module.exports = __webpack_public_path__ + "logoNeumomed.png?e3882a1657177683bd8426e2a15412f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoNeumomed.png
// module id = 770
// module chunks = 0